export const GET_POSTS_SUCCESS = "get/posts/success";
export const GET_POSTS_ERROR = "get/posts/error";
export const GET_POSTS_LOADING = "get/posts/loading";
export const GET_POSTS_RESET = "get/posts/reset";

//bm